import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { Props as FormProps } from './types.tsx';

const AsyncInlineCardCreateFormComp = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-inline-card-create-form" */ './main'),
);

export const AsyncInlineCardCreateForm = (props: Omit<FormProps, 'intl'>) => (
	<ErrorBoundary id="async-inline-card-create-form" packageName="JiraPlatformBoardKit">
		<Placeholder name="async-inline-card-create-form" fallback={null}>
			<AsyncInlineCardCreateFormComp {...props} />
		</Placeholder>
	</ErrorBoundary>
);
